import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { TemplateLayoutLanguageService } from '@fi-app/template/template-layout-language.service';
import { TemplateModel } from '@fi-app/template/template.model';
import { BaseItemModelService } from '@fi-app/template/base-item.model';
import { TemplateControlType } from '@fi-app/template/types/template-control-type';

@Component({
    selector: 'fi-document-template-item-options',
    templateUrl: './document-template-item-options.component.html',
    styleUrls: ['./document-template-item-options.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-document-template-item-options' },
    standalone: false,
})
export class FiDocumentTemplateItemOptionsComponent implements OnChanges {
    @Input() item: BaseItemModelService;
    @Input() templateLayout;
    @Input() template: TemplateModel;

    show2colOption: boolean = true;
    protected tabsSelectedIndex: number;
    protected tabsColumnsSelectedIndex: number;

    constructor(public templateLayoutLanguageService: TemplateLayoutLanguageService) {}

    IsLayoutLanguageSelected(languageId) {
        return this.templateLayoutLanguageService.IsLayoutLanguageSelected(languageId);
    }

    isImageElement() {
        return this.item.controlId === TemplateControlType.Image;
    }

    onMediaBankFileChanged($event) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.show2colOption = !isItemInColumnLayout(this.templateLayout, this.item);
    }
}

function isItemInColumnLayout(templateLayout, item) {
    return templateLayout.placeholders.some((list) => {
        return (
            list.children &&
            list.children.some((childList) => {
                return childList.items.some((childListItem) => childListItem === item);
            })
        );
    });
}
